import { type RefObject, useEffect, useState } from 'react';

type ScrollProxyProps = {
  proxyRef: RefObject<HTMLDivElement | null>;
  bodyTableRef: RefObject<HTMLTableElement | null>;
};

export const ScrollProxy = ({ proxyRef, bodyTableRef }: ScrollProxyProps) => {
  const [spacerWidth, setSpacerWidth] = useState(0);

  useEffect(() => {
    const bodyTable = bodyTableRef.current;
    if (!bodyTable) return;

    const observer = new ResizeObserver(() => {
      setSpacerWidth(bodyTable.scrollWidth);
    });

    observer.observe(bodyTable);
    // 初期値設定
    setSpacerWidth(bodyTable.scrollWidth);

    return () => observer.disconnect();
  }, [bodyTableRef]);

  return (
    <div ref={proxyRef} className="overflow-x-auto overflow-y-hidden">
      <div style={{ width: spacerWidth, height: 1 }} />
    </div>
  );
};
